import { render, staticRenderFns } from "./LotsTable.vue?vue&type=template&id=625ae1fd&"
import script from "./LotsTable.vue?vue&type=script&lang=js&"
export * from "./LotsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports